const DADOS_VERIFICACAO_NOTIFICACAO_KEY = 'dadosVerificacaoNotificacao'
const INTERVALO_VERIFICACAO_NOTIFICACAO = 15 * 60 * 1000 // 15 minutos
const INTERVALO_ATUALIZACAO_APOS_ACAO = 60 * 1000 // 1 minuto

function lerNotificacoesCache() {
  try {
    const raw = localStorage.getItem(DADOS_VERIFICACAO_NOTIFICACAO_KEY)
    if (!raw) return null

    const dados = JSON.parse(raw)
    if (
      typeof dados?.timestamp !== 'number' ||
      typeof dados?.mensagens !== 'number' ||
      typeof dados?.notificacoes !== 'number'
    ) {
      return null
    }

    return dados
  } catch {
    return null
  }
}

function salvarNotificacoesCache(mensagens, notificacoes, timestamp = Date.now()) {
  localStorage.setItem(DADOS_VERIFICACAO_NOTIFICACAO_KEY, JSON.stringify({
    timestamp,
    mensagens,
    notificacoes,
  }))
}

function agendarAtualizacaoProximoMinuto() {
  const dados = lerNotificacoesCache()
  if (!dados) return

  const timestamp = Date.now() - (INTERVALO_VERIFICACAO_NOTIFICACAO - INTERVALO_ATUALIZACAO_APOS_ACAO)
  salvarNotificacoesCache(dados.mensagens, dados.notificacoes, timestamp)
}

export default {
  DADOS_VERIFICACAO_NOTIFICACAO_KEY,
  INTERVALO_VERIFICACAO_NOTIFICACAO,
  lerNotificacoesCache,
  salvarNotificacoesCache,
  agendarAtualizacaoProximoMinuto,
}
